import { User, Phone, Mail, Share2, Hash } from 'lucide-react';

const NAVY = '#004195';

const Field = ({
  icon: Icon,
  label,
  value,
}: {
  icon: any;
  label: string;
  value?: React.ReactNode;
}) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
    <div
      style={{
        marginTop: '2px',
        display: 'flex',
        height: '32px',
        width: '32px',
        flex: '0 0 32px',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        background: 'rgba(0, 48, 135, 0.06)',
        color: NAVY,
      }}
    >
      <Icon size={15} strokeWidth={2} />
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <span
        style={{
          fontSize: '15px',
          fontWeight: 500,
          textTransform: 'uppercase',
          letterSpacing: '0.03em',
          color: '#94a3b8',
        }}
      >
        {label}
      </span>
      <span style={{ fontSize: '16px', fontWeight: 600, color: '#1e293b' }}>{value || '—'}</span>
    </div>
  </div>
);

const cardStyle: React.CSSProperties = {
  width: '100%',
  borderRadius: '14px',
  border: '1px solid #e2e8f0',
  background: '#fff',
  padding: '20px',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};

const cardHeaderStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '14px',
  paddingBottom: '14px',
  borderBottom: '1px solid #f1f5f9',
};

const cardHeaderLabelStyle: React.CSSProperties = {
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  color: '#64748b',
};

const fieldGridStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  columnGap: '14px',
  rowGap: '14px',
};

const UserDetails = (props: any) => {
  const { userDetails, columns } = props;
  const gridCols = columns && columns > 0 ? columns : 2;

  const source = userDetails?.partnerId
    ? 'Affiliate Referral'
    : userDetails?.referredBy
      ? 'User Referral'
      : userDetails?.onboardedFrom || 'DOCUMITRA';

  return (
    <div key={userDetails?.id} style={{ marginBottom: '20px' }}>
      <div
        style={{
          fontSize: '19px',
          fontWeight: 600,
          color: '#1e293b',
          marginBottom: '14px',
        }}
      >
        Basic User Information
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          paddingTop: '4px',
        }}
      >
        <div style={cardStyle}>
          <div style={cardHeaderStyle}>
            <User size={15} color={NAVY} />
            <span style={cardHeaderLabelStyle}>Customer</span>
          </div>

          <div style={{ ...fieldGridStyle, gridTemplateColumns: `repeat(${gridCols}, minmax(0, 1fr))` }}>
            <Field icon={User} label="Name" value={userDetails?.name} />
            <Field icon={Phone} label="Phone" value={userDetails?.phone} />
            <Field icon={Mail} label="Email" value={userDetails?.email} />
            <Field icon={Share2} label="Source" value={source} />
            {userDetails?.partnerId && (
              <Field icon={Hash} label="Partner ID" value={userDetails?.partnerId} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
